import firebase from 'firebase/app'
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyBdDOm-F7VxXw-l9PgBJZQlkezckId81TI",
    authDomain: "pandemic-with-friends.firebaseapp.com",
    databaseURL: "https://pandemic-with-friends.firebaseio.com",
    projectId: "pandemic-with-friends",
    storageBucket: "pandemic-with-friends.appspot.com",
    messagingSenderId: "671557933127",
    appId: "1:671557933127:web:a1de66483721109cfc7962"
  };
  // Initialize Firebase
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  
  export default firebaseApp.firestore()